import React from "react";
import { Button } from "./ui/button";
import { loadImage } from "../../common/services/uiService";

const SaveCancelButtons = ({
  onSave,
  onCancel,
  isSaving = false,
  disabled = false,
  saveLabel = "Save",
  cancelLabel = "Cancel",
}) => {
  const loadingIcon = loadImage("loading_continuous.gif");

  return (
    <div className="flex justify-end mt-3 gap-2">
      <Button
        variant="outline"
        onClick={() => onCancel()}
        disabled={disabled || isSaving}
      >
        {cancelLabel}
      </Button>
      <Button onClick={() => onSave()} disabled={disabled || isSaving}>
        <div className="flex justify-center items-center h-5">
          {isSaving ? (
            <img src={loadingIcon} alt="loading" className="w-7 h-7" />
          ) : (
            <span>{saveLabel}</span>
          )}
        </div>
      </Button>
    </div>
  );
};

export default SaveCancelButtons;
